export interface RecordingStudioCompSegment {
  id: number
  takeId: number
  startMs: number
  endMs: number
}

export function normalizeCompTimeMs(value: unknown): number {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return 0
  return Math.max(0, Math.round(numeric))
}

export function normalizeCompSegment(segment: RecordingStudioCompSegment): RecordingStudioCompSegment {
  return {
    id: Math.max(1, Math.round(Number(segment.id) || 1)),
    takeId: Math.max(1, Math.round(Number(segment.takeId) || 1)),
    startMs: normalizeCompTimeMs(segment.startMs),
    endMs: normalizeCompTimeMs(segment.endMs),
  }
}

export function sortedCompSegments(
  segments: readonly RecordingStudioCompSegment[] | undefined,
): RecordingStudioCompSegment[] {
  return (segments ?? [])
    .map(normalizeCompSegment)
    .filter((segment) => segment.endMs > segment.startMs)
    .sort((a, b) => a.startMs - b.startMs || a.endMs - b.endMs || a.id - b.id)
}

export function compSegmentsValid(
  segments: readonly RecordingStudioCompSegment[] | undefined,
  validTakeIds?: ReadonlySet<number>,
): boolean {
  const sorted = sortedCompSegments(segments)
  if (sorted.length !== (segments ?? []).length) return false
  let previousEnd = -1
  for (const segment of sorted) {
    if (validTakeIds && !validTakeIds.has(segment.takeId)) return false
    if (segment.startMs < previousEnd) return false
    previousEnd = segment.endMs
  }
  return true
}

export function compHasUsableSegments(
  enabled: boolean | undefined,
  segments: readonly RecordingStudioCompSegment[] | undefined,
  validTakeIds?: ReadonlySet<number>,
): boolean {
  return Boolean(enabled) && sortedCompSegments(segments).length > 0 && compSegmentsValid(segments, validTakeIds)
}
